<template>
  <div>
    <RightMenu></RightMenu>
    <i @click="setShowRight(true)">
      <a class="fas fa-bars" style="color:#fff"></a>
    </i>
  </div>
</template>
<script>
import RightMenu from "@/components/RightMenuIcon/RightMenu.vue";
import { mapMutations, mapState } from "vuex";
export default {
  name: "RightMenuIcon",
  components: {
    RightMenu: RightMenu
  },
  methods: {
    ...mapMutations([
      "setMessageText",
      "clearMessageText",
      "startLoad",
      "endLoad",
      "setCompanyList",
      "setUserId",
      "setMenu",
      "setShowRight"
    ])
  }
};
</script>
<style scoped>
</style>
